import type { EventReanalysisSkipReason } from "@sitescene/types";

import {
	EventReanalysisKind,
	EventReanalysisOutcome,
	EventReanalysisSource,
	EventReanalysisStatus,
} from "@sitescene/types";

/** Labels shared by the reanalysis pages. */

export const KIND_LABELS: Record<EventReanalysisKind, string> = {
	[EventReanalysisKind.FalseAlarm]: "False alarm",
	[EventReanalysisKind.Misclassified]: "Misclassified",
	[EventReanalysisKind.Missed]: "Missed",
};

export const OUTCOME_LABELS: Record<EventReanalysisOutcome, string> = {
	[EventReanalysisOutcome.Confirmed]: "Confirmed",
	[EventReanalysisOutcome.NotConfirmed]: "Not confirmed",
};

export const SOURCE_LABELS: Record<EventReanalysisSource, string> = {
	[EventReanalysisSource.Dashboard]: "the customer dashboard",
	[EventReanalysisSource.ShadowRealm]: "the Shadow Realm",
};

export const STATUS_LABELS: Record<EventReanalysisStatus, string> = {
	[EventReanalysisStatus.Completed]: "Completed",
	[EventReanalysisStatus.Failed]: "Failed",
	[EventReanalysisStatus.Queued]: "Queued",
	[EventReanalysisStatus.Reverted]: "Reverted",
	[EventReanalysisStatus.Running]: "Running",
};

export const SKIP_REASON_LABELS: Record<EventReanalysisSkipReason, string> = {
	anchoredUnparseable: "The anchored reply could not be read",
	clipMissing: "The clip is missing",
	clipTooLarge: "The clip is too large to send",
	noSpec: "The class has no discriminator spec",
	unknownClass: "The class is not in the taxonomy",
};
